<template>
  <v-container>
    <v-layout align-center  justify-center>
      <v-flex>
        <v-tabs
          ripple
          color="primary"
          dark
          v-model="activetab"
        >


          <v-tab href="#tab-1">
            Создание постоянно действующего дисс совета
          </v-tab>
          <v-tab href="#tab-2" v-if="petition !== undefined || local_admin">
            Сведения о кандидатах в члены дисс совета
          </v-tab>
          <v-tab href="#tab-3" v-if="petition !== undefined || local_admin">
            Сведения о научной эффективности
          </v-tab>

          <v-tabs-items touchless>

            <v-tab-item
              :key="1"
              :value="'tab-' + 1"
            >
              <CouncilCreation @setPetition="setPetition"></CouncilCreation>
            </v-tab-item>

            <v-tab-item
              :key="2"
              :value="'tab-' + 2"
            >
              <PublicationsList v-bind:petition=petition v-bind:local_admin=local_admin
                                v-bind:activetab=activetab></PublicationsList>
            </v-tab-item>
            <v-tab-item
              :key="3"
              :value="'tab-' + 3"
            >
              <ScientificEffect v-bind:petition=petition v-bind:local_admin=local_admin
                                v-bind:activetab=activetab></ScientificEffect>
            </v-tab-item>

          </v-tabs-items>

        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import urls from "../../urls.js"
    import {makeGetRequest} from "../../../../helper";
    import CouncilCreation from "@/modules/petition/pages/council/CouncilCreation";
    import PublicationsList from "@/modules/petition/pages/council/PublicationsList";
    import ScientificEffect from "@/modules/petition/pages/council/ScientificEffect";

    export default {
        name: "Council",
        components: {
            CouncilCreation,
            PublicationsList,
            ScientificEffect
        },
        methods: {
            setPetition: function (item) {
                this.petition = item
            },
        },
        data() {
            return {
                local_admin: false,
                petition: undefined,
                activetab: "tab-1"
            }
        },
        created() {

            makeGetRequest(urls.getUrl('admin|petition|checker|petition|self-local-admin', 'get'))
                .then((resp) => {
                    return resp.json();
                }).then((json) => {
                let local_admin = json['allowed'];
                if (local_admin) {
                    this.local_admin = local_admin
                } else {
                    this.local_admin = false
                }

            });


        },

    }
</script>

<style scoped>

</style>
